import { Component, inject, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ShopService } from '@app/services/shops/shop.service';
import { MULTI_SHIPMENT_DISPLAY_RULES, MultiShipmentFormGroup } from '../../model';

@Component({
  selector: 'multi-shipment-display-conditions-tab',
  templateUrl: './display-conditions-tab.component.html',
  styleUrls: ['./display-conditions-tab.component.scss'],
  standalone: false,
})
export class DisplayConditionsTabComponent {
  @Input({ required: true }) formGroup!: FormGroup<MultiShipmentFormGroup>;

  readonly displayRules = [...MULTI_SHIPMENT_DISPLAY_RULES];
  readonly displayRulesEntities = this.displayRules.map((rule) => rule.entity);
  readonly shopCurrencySymbol = inject(ShopService).shopCurrencySignal();
}
